import React from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { H4, InputText } from "../../../../assets/styles/Typography";

const MoleculeAnalysisCard = ({ 
  title = "정보 개요 요약", 
  buttonText = "분석 상세 확인", 
  onButtonClick, 
  values = {},
  showButton = true,
  type = "default"
}) => {
  // 기본 데이터와 템플릿 데이터 분리

  const getAnalysisData = () => {
    if (type === "template") {
      return [
        {
          label: "디스플레이 정보",
          value: values.deviceInfo || "디스플레이 정보"
        },
        {
          label: "콘텐츠 타입",
          value: values.dataTypeText || "제목"
        },
        // {
        //   label: "공공 데이터",
        //   value: values.analysisData?.source || values.source || "출처"
        // },
        {
          label: "디자인 모드",
          value: Array.isArray(values.designConcept) 
            ? values.designConcept.join(", ") 
            : values.designConcept || "미니멀 & 고대비 디자인 (가독성 강화)"
        },
        {
          label: "메시지",
          value: values.messages || "정보전달형",
          // hasLink: true,
          // linkText: "자세히 보기"
        },
      
      ];
    } else {
      // 기본 데이터
      return [
        {
          label: "기기 정보",
          value: values.deviceInfo || "디스플레이 정보"
        },
        {
          label: "제목",
          value: values.analysisData?.title || values.title || "제목"
        },
        {
          label: "출처",
          value: values.analysisData?.source || values.source || "출처"
        },
        {
          label: "핵심 메시지",
          value: values.analysisData?.message || values.message || "민, 관, 군이 참여하는 고성 간성지역 대표 기리축제 소개"
        }
      ];
    }
  };

  const analysisData = getAnalysisData();


  return (
    <AnalysisCard>
      {showButton && (
        <CardHeader>
          <H4 color="gray800">{title}</H4>
          {/* {buttonText && (
            <Button Small Outline onClick={onButtonClick}>
              <InputText color="gray700">{buttonText}</InputText>
            </Button>
          )} */}
        </CardHeader>
      )}
      
      <AnalysisTable>
        {analysisData.map((item, index) => (
          <AnalysisRow key={index}>
            <AnalysisLabel>{item.label}</AnalysisLabel>
            <AnalysisValue>
              <ValueText>{item.value}</ValueText>
              {item.hasLink && (
                <LinkText onClick={onButtonClick}>
                  {item.linkText}
                </LinkText>
              )}
            </AnalysisValue>
          </AnalysisRow>
        ))}
      </AnalysisTable>
    </AnalysisCard>
  );
};

export default MoleculeAnalysisCard;

const AnalysisCard = styled.div`
  background: #F8F9FA;
  border: 1px solid #E9ECEF;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const AnalysisTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const AnalysisRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  min-height: 40px;
`;

const AnalysisLabel = styled.div`
  min-width: 100px;
  width: 100px;
  font-size: 18px;
  font-weight: 600;
  color: black;
  border-radius: 4px;
  text-align: left;
  display: flex;
  align-items: flex-start;
  white-space: nowrap;
  height: auto;
  line-height: 1.4;
  padding: 8px 0;
  box-sizing: border-box;
`;

const ValueText = styled.span`
  /* flex: 1 제거 */
  /* margin-right: 8px 제거 (LinkText의 margin-left로 충분) */
`;

const AnalysisValue = styled.div`
  flex: 1;
  font-size: 18px;
  color: ${palette.gray800};
  text-align: left;
  display: flex;
  align-items: flex-start;
  height: auto;
  line-height: 1.4;
  padding: 8px 0;
  box-sizing: border-box;
  flex-wrap: wrap;
`;

const LinkText = styled.span`
  color: ${palette.primary};
  cursor: pointer;
  margin-left: 8px;
  text-decoration: underline;
  font-size: 16px;
  white-space: nowrap;
  
  &:hover {
    opacity: 0.8;
  }
`; 